import React, { useEffect, useState } from 'react';
import './InspectionBubbleDocuments.css';
import _, { startCase } from 'lodash';
import { FaDownload, FaTrash, FaUserLock } from 'react-icons/fa';
import BubbleCard from '../../BubbleCard';
import FileUploader from '../../FileUploader';
import { get, uuid } from '../../../utility/utility';
import InspectionOnsiteDocumentCard from '../cards/InspectionOnsiteDocumentCard';
import { INSPECTION_DOCUMENT_ACTIONS } from '../../../utility/InspectionsUtils';

function InspectionBubbleDocuments({
  inspection,
  documents,
  dispatchInspectionsDocumentPatch,
  dispatchInspectionsDocumentDelete,
  dispatchInspectionsDocumentGet,
  inspectionsPatchDocumentsIsLoading,
  inspectionsDeleteDocumentsIsLoading,
  handleButtonInspectionDocumentVisibilityFormOpen,
}) {
  const [documentsUploadsState, setDocumentsUploadsState] = useState([]);

  const handleFileDrop = (files) => {
    const simplifiedUploads = files.map((file) => ({
      _id: uuid(),
      filename: file.name,
      storedAt: new Date(),
    }));

    setDocumentsUploadsState(simplifiedUploads);
    for (const file of files) {
      dispatchInspectionsDocumentPatch(inspection, file);
    }
  };

  useEffect(() => {
    setDocumentsUploadsState((currentUploads) => {
      const filtered = currentUploads.filter((upload) => {
        const matchingDoc = documents.find(
          (doc) => doc.filename === upload.filename
            && new Date(doc.storedAt) >= new Date(upload.storedAt),
        );

        return !matchingDoc; // keep if not matched by more recent doc
      });

      return filtered;
    });
  }, [inspectionsPatchDocumentsIsLoading, inspectionsDeleteDocumentsIsLoading, documents]);

  const renderInspectionOnsiteDocumentCard = (document) => {
    const bookingId = get(document, 'bookingId', false);
    const secondaryActions = [];
    const permittedActions = get(document, 'actions', []);

    for (const action of permittedActions) {
      switch (action) {
        case INSPECTION_DOCUMENT_ACTIONS.download:
          secondaryActions.push({
            _id: uuid(),
            text: startCase(action),
            icon: <FaDownload title={startCase(action)} />,
            onClick: () => (dispatchInspectionsDocumentGet(inspection, { documentId: get(document, '_id') }, false)),
          });
          break;

        case INSPECTION_DOCUMENT_ACTIONS.edit:
          secondaryActions.push({
            _id: uuid(),
            text: startCase(action),
            icon: <FaUserLock title={startCase(action)} />,
            onClick: () => handleButtonInspectionDocumentVisibilityFormOpen(inspection, get(document, '_id')),
          });
          break;

        case INSPECTION_DOCUMENT_ACTIONS.delete:
          secondaryActions.push({
            _id: uuid(),
            text: startCase(action),
            icon: <FaTrash title={startCase(action)} />,
            onClick: () => dispatchInspectionsDocumentDelete(inspection, { documentIds: [get(document, '_id')] }),
          });
          break;
        default:
          break;
      }
    }
    return (
      <InspectionOnsiteDocumentCard
        inspectionId={get(inspection, '_id')}
        key={document._id}
        document={document}
        primaryAction={() => dispatchInspectionsDocumentGet(inspection, { documentId: get(document, '_id') })}
        secondaryActions={secondaryActions}
        isLinked={bookingId}
      />
    );
  };

  const renderTitle = (docs) => {
    const title = ['Documents'];
    if (docs.length) {
      title.push(`(${docs.length})`);
    }
    return title.join(' ');
  };

  return (
    <BubbleCard title={renderTitle(documents)} style={{ marginBottom: '10px' }} retrieve>
      {documents.map((document) => (
        renderInspectionOnsiteDocumentCard(document)
      ))}

      <div className="inspection-bubble-documents-container">
        {documentsUploadsState.map((document) => (
          <InspectionOnsiteDocumentCard
            document={document}
            primaryAction={() => { }}
            secondaryActions={[]}
            isLoading
            isLinked={false}
          />
        ))}
        <div style={{ padding: '10px' }}>
          <FileUploader onFileDrop={handleFileDrop} id="document" type="file" name="filePicker" multiple />
        </div>
      </div>
    </BubbleCard>
  );
}

export default InspectionBubbleDocuments;
